











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'
import {CargaTempCollection} from '@/model/collection/CargaTempCollection'
import {ListCargaTempSchema} from '@/schema/resource/CargaTemp/ListCargaTempSchema'
import {CsvCargaTempSchema} from '@/schema/resource/CargaTemp/CsvCargaTempSchema'

@Component
export default class ListCargaTempView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaTempSchema()
  collection = new CargaTempCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaTemp) {
    Helper.pushByName('editCargaTemp', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaTempCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaTemp()
    new CsvCargaTempSchema().downloadCsv(csv.all())
  }
}
